import React from 'react';

function Spinner(props) {
  return (<div class="col-lg-4 col-md-4 col-sm-4 container justify-content-center">
    <div className="fa-3x">
      <i className="fas fa-spinner fa-spin"></i>
    </div></div>);
}

export default Spinner;